import { render, staticRenderFns } from "./GenericSelector.vue?vue&type=template&id=54aaf0d6&scoped=true&"
import script from "./GenericSelector.vue?vue&type=script&lang=js&"
export * from "./GenericSelector.vue?vue&type=script&lang=js&"
import style0 from "./GenericSelector.vue?vue&type=style&index=0&id=54aaf0d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aaf0d6",
  null
  
)

export default component.exports